'use client';

import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { usePathname } from 'next/navigation';

export default function PageTransition({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  return (
    <AnimatePresence data-component-id="src/components/site/PageTransition.tsx:11:4" data-component-path="src/components/site/PageTransition.tsx" data-component-line="11" data-component-end-line="22" data-component-file="PageTransition.tsx" data-component-name="AnimatePresence" data-component-content="%7B%22elementName%22%3A%22AnimatePresence%22%7D" mode="wait" initial={false}>
      <motion.div data-component-id="src/components/site/PageTransition.tsx:12:6" data-component-path="src/components/site/PageTransition.tsx" data-component-line="12" data-component-end-line="21" data-component-file="PageTransition.tsx" data-component-name="motion.div" data-component-content="%7B%22elementName%22%3A%22motion.div%22%7D"
        key={pathname}
        initial={{ opacity: 0, y: 6 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -6 }}
        transition={{ duration: 0.18, ease: 'easeOut' }}
        style={{ height: '100%' }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
